import axios from 'axios';
import { getInstance as getBootstrap } from 'utils/bootstrap';
import getSplashApiClient from 'lib/SplashApiClient/singleton';

export default class GatekeeperApiClient {
    /**
     * @param {SplashApiClient} apiClient
     * @param {number | string} eventId
     * @param {boolean} isHostExperience
     * @param {string} guestAccessHash
     */
    constructor({ guestAccessHash }) {
        const splashAPIClient = getSplashApiClient();
        // Access token set here as there might be a difference between bootstrap and api client access tokens.

        const bootstrap = getBootstrap();
        this.setGuestAccessHash(guestAccessHash);
        const gatekeeperServiceDomain = bootstrap.get(
            'gatekeeperServiceDomain',
            'https://gatekeeper-api.services.splashthat.com',
        );
        const API_URL_OBTAIN_HEARTBEAT = '/gatekeeper/heartbeat';
        const GATEKEEPER_URL_PING_HEARTBEAT = '/api/v1/ping/';

        this.gatekeeperServiceDomain = gatekeeperServiceDomain;
        this.apiUrlObtainHeartbeat = API_URL_OBTAIN_HEARTBEAT;
        this.gatekeeperUrlPingHeartbeat = GATEKEEPER_URL_PING_HEARTBEAT;
        this.splashAPIClient = splashAPIClient;
    }

    /**
     * @param {string} guestAccessHash
     */
    setGuestAccessHash(guestAccessHash) {
        this.guestAccessHash = guestAccessHash;
    }

    getHeartbeatId = async ({ guestId, eventId }) => {
        const baseURL = `${this.apiUrlObtainHeartbeat}`;

        const response = await this.splashAPIClient.post(
            baseURL,
            {
                eventId,
                guestId,
            },
            {
                omitAccessToken: true,
                headers: {
                    'X-Splash-Guest-Access-Hash': this.guestAccessHash,
                },
            },
        );

        return response?.data;
    };

    ping = async ({ heartbeatId }) => {
        const baseURL = `${this.gatekeeperServiceDomain}${this.gatekeeperUrlPingHeartbeat}${heartbeatId}`;
        const response = await axios.get(
            baseURL,
            {},
            {
                omitAccessToken: true,
                headers: {
                    'X-Splash-Guest-Access-Hash': this.guestAccessHash,
                },
            },
        );

        return response.data;
    };
}

export const getGatekeeperApiClient = ({ guestAccessHash }) => new GatekeeperApiClient({ guestAccessHash });
